import { INVOICE_STATUS } from '@/constants'

export const getLatestOverdueDate = (invoices) => {
  const overdueInvoices = invoices.filter(
    (invoice) => invoice.status === INVOICE_STATUS.PAST_DUE,
  )

  if (overdueInvoices.length) {
    return new Date(
      Math.max(...overdueInvoices.map((invoice) => new Date(invoice.dueDate))),
    )
  }

  return null
}

export const hasOverdueInvoices = (invoices) => invoices.some(invoice => invoice.status === INVOICE_STATUS.PAST_DUE)

export default {}
